import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Box, Button, ICommand, setPageTitle } from "Application";
import { CurrentMentorsViewModel } from "./CurrentMentorsViewModel";
import { PageContainer, PageRoot, PageSubHeader } from "Styles/PageStyles";
import { AddStudent } from "Views/Students/Views/Shared/Styles/SharedStudentsTable.styles";
import { CurrentMentorsTable } from "./CurrentMentorsTable";
import { WarningModal } from "Views/Students/Shared/Modals/WarningModal";
import { SearchBox } from "Components/SearchBox/SearchBox";

export const CurrentMentorsView: React.FC<{ onConfirmMentorStatusChangeCommand: ICommand }> = observer(({ onConfirmMentorStatusChangeCommand }) => {
    const [viewModel] = useState(new CurrentMentorsViewModel(onConfirmMentorStatusChangeCommand));

    useEffect(() => {
        setPageTitle("Current Mentors");
        viewModel.getFilteredMentors();
        return () => {
            viewModel.reset();
        };
    }, []);

    return (
        <>
            <PageRoot style={{ background: "#fff" }}>
                <PageContainer>
                    <PageSubHeader>
                        <SearchBox {...viewModel.searchBoxProps} />
                        <AddStudent>
                            <Button command={viewModel.navigateToAddMentorCommand} type="button" displayName={"Add Mentor"} className="add-student" paletteColor="primary" />
                        </AddStudent>
                    </PageSubHeader>
                    {/* endregion filter and upload new resource */}
                    <CurrentMentorsTable
                        mentors={viewModel.mentors}
                        onDeleteMentorCommand={viewModel.moveToPastMentorsCommand}
                        onViewMentorDetailsCommand={viewModel.navigateToMentorDetailsCommand}
                    />
                </PageContainer>
                <WarningModal
                    isOpen={viewModel.showMentorStatusChangeWarning}
                    onClose={viewModel.dismissStatusChangeWarningCommand}
                    onConfirm={viewModel.confirmMoveToPastMentorsCommand}
                    warningMessage="Are you sure you want to move this mentor to past mentors?"
                />
            </PageRoot>
        </>
    );
});
